// extracted by mini-css-extract-plugin
module.exports = {"menuText":"MenuPortfolio_menuText__mTW3m"};